import { memo } from 'react'
import CSSTransition from 'react-transition-group/CSSTransition'

import s from './Transition.module.less'

interface IProps {
  children: JSX.Element
  in?: boolean
  key?: string | number
}

export const TransitionTransformRight = memo<IProps>(function TransitionTransformRight({ children, ...rest }) {
  return (
    <CSSTransition
      {...rest}
      mountOnEnter
      unmountOnExit
      timeout={{ enter: 200, exit: 200 }}
      classNames={{
        appear: s['transform-right-enter'],
        appearActive: s['transform-right-enter-active'],
        enter: s['transform-right-enter'],
        enterActive: s['transform-right-enter-active'],
        exit: s['transform-right-exit'],
        exitActive: s['transform-right-exit-active']
      }}
    >
      {children}
    </CSSTransition>
  )
})
